import { usersApi } from 'entities/users';

type CreateImageResponseDataType = {
  image_reference: string | null;
};

const productImageApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    createImage: builder.mutation<CreateImageResponseDataType, any>({
      query: (body) => ({
        url: '/shop/admin/v1/image/create-image',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateImageMutation } = productImageApi;
